"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIdObject = void 0;
var id_object_1 = require("../structs/id-object");
var class_transformer_1 = require("class-transformer");
function parseIdObject(id) {
    if (!(id instanceof id_object_1.IdObject)) {
        id = (0, class_transformer_1.plainToInstance)(id_object_1.IdObject, { id: id });
    }
    return id;
}
exports.parseIdObject = parseIdObject;
//# sourceMappingURL=parse-id-object.js.map